import axios, { AxiosPromise } from "axios";

export interface MTeamChatResponse {
    reply: string;
}

export interface MTeamEstadoResponse {
    activo: boolean;
}

export function postMensajeMTeam(message: string): AxiosPromise<MTeamChatResponse> {
    return axios.post('api/agenteMTeam/chat', { message });
}

export function deleteResetMTeam(): AxiosPromise<{ ok: boolean; message: string }> {
    return axios.delete('api/agenteMTeam/reset');
}

export function getEstadoMTeam(): AxiosPromise<MTeamEstadoResponse> {
    return axios.get('api/agenteMTeam/estado');
}

export function patchEstadoMTeam(activo: boolean): AxiosPromise<MTeamEstadoResponse> {
    return axios.patch('api/agenteMTeam/estado', { activo });
}
